import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import {storeToRefs} from 'pinia';
import {useFeatureFlagStore} from '@/stores/featureFlagStore';
import {usePermissionStore} from '@/stores/permissionStore';
import type {PermissionName} from '@/api/models/permissions/permissionName';
import {handleFeatureFlagGuard} from './featureFlagGuard';

// can(), not meta.permission: these permissions are outside the rollout, which meta.permission honours.
export function beforeEnterApprovalManagement(permission: PermissionName) {
    // Named, because wrapGuard() rejects anonymous guards in dev builds.
    return async function approvalManagementGuard(
        _to: RouteLocationNormalized,
        from: RouteLocationNormalized
    ): Promise<NavigationGuardReturn> {
        const permissionStore = usePermissionStore();
        await permissionStore.isReady();

        if (!permissionStore.can(permission)) {
            return {name: 'Home'};
        }

        const {approvalManagement} = storeToRefs(useFeatureFlagStore());

        return await handleFeatureFlagGuard(approvalManagement, from);
    };
}
